// Exclude only the translation compatibility mirror from semantic comparison.
// A native M/C form must retain focus when Redux echoes back the same segment
// just saved; real external changes still replace the document.
export function semanticAuthorProblems(items) {
  return (items || []).map(segment => {
    const result = {...segment};
    if (Array.isArray(result.choiceDetails)) {
      const details = result.choiceDetails.map(({text, ...metadata}) => metadata);
      if (details.some(detail => Object.keys(detail).length)) result.choiceDetails = details;
      else delete result.choiceDetails;
    }
    return result;
  });
}
export function isAuthorReduxEcho(incoming, emitted) {
  return Array.isArray(incoming) && Array.isArray(emitted) &&
    JSON.stringify(semanticAuthorProblems(incoming)) === JSON.stringify(semanticAuthorProblems(emitted));
}
